import React from "react";
import { classNames } from "../../utils";
import { BulkUploadError } from "../../api/ReportUploadApi";
import {
  CheckIcon,
  ExclamationCircleIcon as ExclamationIcon,
} from "@heroicons/react/24/outline";
import { buildColumnToKeyMap } from "./helpers";

type Props = {
  data: string[][];
  errors: BulkUploadError[];
};

const BulkDataTable = ({ data, errors }: Props) => {
  const keyToColumn = buildColumnToKeyMap(data.at(0) ?? []);

  return (
    <div className="">
      {data?.map((row, idx) => {
        return (
          <RowData
            key={idx}
            row={row}
            idx={idx}
            errors={errors}
            keyToColumn={keyToColumn}
          />
        );
      })}
    </div>
  );
};

function RowData({
  row,
  idx,
  errors,
  keyToColumn,
}: {
  row: string[];
  idx: number;
  errors: BulkUploadError[];
  keyToColumn: {
    [key: string]: string;
  };
}) {
  const isHeader = idx === 0;

  function rowHasError(): boolean {
    return errors.some((e) => e.row === idx);
  }

  function columnHasError(colIdx: number): boolean {
    return errors.some(
      (e) => e.column.toLowerCase() === keyToColumn[colIdx] && e.row === idx
    );
  }

  return (
    <div
      className={classNames(
        "flex overflow-auto text-sm",
        isHeader ? "rounded-t-lg" : ""
      )}
    >
      <div
        className={classNames(
          "flex py-2 w-10 truncate pl-2",
          isHeader ? "font-semibold bg-slate-100 " : "border-b"
        )}
      >
        {isHeader ? (
          ""
        ) : rowHasError() ? (
          <ExclamationIcon className="w-4 text-red-500" />
        ) : (
          <CheckIcon className="w-4 text-green-500" />
        )}
      </div>
      {row.map((col, colIdx) => (
        <div
          key={colIdx}
          className={classNames(
            "flex justify-between p-2 w-28   truncate",
            isHeader ? "font-semibold bg-slate-100 " : "border-b",
            columnHasError(colIdx) ? "bg-red-100" : ""
          )}
        >
          <div>{col.length === 0 ? <span>&#8709;</span> : col}</div>
        </div>
      ))}
    </div>
  );
}

export default BulkDataTable;
